import React from 'react';
import {
  CalendarOutlined,
  ClockCircleOutlined,
  DesktopOutlined,
  TeamOutlined,
} from '@ant-design/icons';

interface Props {
  openJobs: number;
  activeCandidates: number;
  interviewsThisWeek: number;
  followUpCount: number;
}

const STATS: {
  key: keyof Props;
  label: string;
  hint: string;
  icon: React.ReactNode;
}[] = [
  {
    key: 'openJobs',
    label: 'Open jobs',
    hint: 'Currently recruiting',
    icon: <DesktopOutlined />,
  },
  {
    key: 'activeCandidates',
    label: 'Active candidates',
    hint: 'Available in your workspace',
    icon: <TeamOutlined />,
  },
  {
    key: 'interviewsThisWeek',
    label: 'Interviews this week',
    hint: 'Scheduled conversations',
    icon: <CalendarOutlined />,
  },
  {
    key: 'followUpCount',
    label: 'Needs follow-up',
    hint: 'Waiting for feedback',
    icon: <ClockCircleOutlined />,
  },
];

const DashboardStats: React.FC<Props> = (values) => (
  <dl className="dashboard-stats" aria-label="Hiring summary">
    {STATS.map((stat) => (
      <div className="dashboard-stats__item" key={stat.key}>
        <div>
          <dt>{stat.label}</dt>
          <dd>{values[stat.key]}</dd>
          <span>{stat.hint}</span>
        </div>
        <span className="dashboard-stats__icon" aria-hidden>
          {stat.icon}
        </span>
      </div>
    ))}
  </dl>
);

export default DashboardStats;
